// NO_MODIFY_THIS_FILE_BAKKA
import { activityActions } from '../../constants';

const initialState = {
  date: null,
  error: null,
  activeOption: 0,
  selectedDuration: null,
  showDisponibilities: false,
  selectedActivity: null,
  course: null,
  types: [],
  typesFilters: [],
};

const activityReducer = (state = initialState, action) => {
  switch (action.type) {
    case activityActions.SET_ACTIVE_OPTION:
      return { ...state, activeOption: action.payload };
    case activityActions.SET_SELECTED_DURATION:
      return { ...state, selectedDuration: action.payload };
    case activityActions.SET_SHOW_DISPONIBILITIES:
      return { ...state, showDisponibilities: action.payload };
    case activityActions.SET_COURSE:
      return { ...state, course: action.payload };
    case activityActions.SET_TYPES:
      return { ...state, types: action.payload };
    case activityActions.SET_TYPES_FILTERS:
      return { ...state, typesFilters: action.payload };
    case activityActions.SET_ERROR:
      return { ...state, error: action.payload };
    case activityActions.SET_SELECTED_ACTIVITY:
      return { ...state, selectedActivity: action.payload };
    case activityActions.RESET_STATE:
      return {
        ...initialState,
        showDisponibilities: action.payload.isPublic === true,
      };
    default:
      return state;
  }
};

export default activityReducer;
